import checkboxComponent from "@/components/child/form/checkbox.vue";
import { Component } from "@/decorators";
import EstoqueModel from "@/models/estoqueModel";
import estoqueService from "@/services/estoqueService";

import EditComponentBase from "../editComponentBase";

import "../crud.scss";

@Component({
    components: {
        checkboxComponent,
    },
})
export default class EstoqueEditComponent extends EditComponentBase<EstoqueModel> {
    // State computed props

    private async beforeMount() {
        await this.setPropsCached(estoqueService, "estoque", new EstoqueModel());
    }
}
